<template>
	<div id="app">
		<!-- <loading v-show="isloading"></loading> -->
		<router-view v-if="isRouterAlive"></router-view>
	</div>
</template>

<script>
	import store from "../src/store/index";
	export default {
		name: "app",
		provide() {
			return {
				reload: this.reload,
			};
		},
		data() {
			return {
				isRouterAlive: true,
			};
		},
		


		methods: {
				
			
			reload() {
				this.isRouterAlive = false;
				this.$nextTick(function () {
					this.isRouterAlive = true;
				});
			},
		},
		created() {
			if(!localStorage.getItem("UserToken")){
				localStorage.setItem("UserToken",'');
			}
			// var token = localStorage.getItem("token");
			// var tokenTime = localStorage.getItem("tokenTime") * 1000;
			// var day = new Date().getTime();
			// // if (!token || token === null) {
			// 	this.$get("token").then((res) => {
			// 		console.log(res);
			// 		localStorage.setItem("token", res.data.token);
			// 		localStorage.setItem("tokenTime", res.data.last_time);
			// 	});
			// // }
		},
	};
</script>

<style>
	#app {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		height: 100%;
	}
</style>
